import React from 'react';
import '../css/policybenefits.css';
import { Helmet } from 'react-helmet-async';

const PolicyBenefits = () => {
  return (
    <div className="policy-benefits-section">
      <Helmet>
        <title>Insurance Benefits | Clarity in Insurance | Policy Samjho</title>
        <meta
          name="description"
          content="Explore the key insurance benefits with Policy Samjho. We provide clarity in insurance by breaking down complex terms and offering personalized policy insights."
        />
        <meta
          name="keywords"
          content="insurance benefits, clarity in insurance, policy insights, insurance guidance, understand insurance policy, insurance policy help"
        />
        <link rel="canonical" href="https://policysamjho.com/insurance-benefits" />
        
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Insurance Benefits",
            "description": "Clear, simple, and jargon-free insurance benefits explained by Policy Samjho to help you make informed choices.",
            "provider": {
              "@type": "Organization",
              "name": "Policy Samjho",
              "url": "https://policysamjho.com"
            },
            "serviceType": "Insurance Guidance & Policy Benefits",
            "areaServed": "IN",
            "url": "https://policysamjho.com/insurance-benefits",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "18005703990",
              "email": "info@policysamjho.com",
              "contactType": "customer service"
            }
          })}
        </script>
      </Helmet>

      <div className="policy-benefit-card">
        <h2 className="card-heading">Clarity in Insurance: De-Jargonized</h2>
        <h4 className="card-subheading">Forget fine print forever</h4>
        <p className="benefitscard-description">
          Policies explained in simple words—no jargon, just clarity.
        </p>
      </div>

      <div className="policy-benefit-card">
        <h2 className="card-heading">Smart Policy Insights</h2>
        <h4 className="card-subheading">Get what suits you</h4>
        <p className="benefitscard-description">
          We match your needs with plans, not random policy bundles.
        </p>
      </div>

      <div className="policy-benefit-card">
        <h2 className="card-heading">Expert Insurance Guidance</h2>
        <h4 className="card-subheading">Real help, always on</h4>
        <p className="benefitscard-description">
          Speak with our experts who care—not agents chasing commissions.
        </p>
      </div>
    </div>
  );
};

export default PolicyBenefits;